export default __webpack_public_path__ + "static/media/mail.b4f0f4f1.svg";